module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="js-h2h-link h2h-link js-tab active">Head To Head</a>\n<a class="js-multi-player-link js-tab multi-player-link">Multiplayer (Coach Only)</a>';
}
return __p;
};
